<div class="loader-container text-{{ textPosition }}" [class.is-card]="isCard">
  <div class="text">
    <ng-content></ng-content>
  </div>
  <div class="spinners">
    <!-- <mat-progress-spinner mode="indeterminate" [diameter]="72" [strokeWidth]="2" color="accent" class="spinner-1">
    </mat-progress-spinner>
    <mat-progress-spinner mode="indeterminate" [diameter]="84" [strokeWidth]="2" color="accent" class="spinner-2">
    </mat-progress-spinner>
    <mat-progress-spinner mode="indeterminate" [diameter]="100" [strokeWidth]="2" color="accent" class="spinner-3">
    </mat-progress-spinner> -->

    <div class="dot-spin"></div>
  </div>
</div>
